var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXxNetworkCircleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 39,
    viewBox: "0 0 36 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3223 7.73555C27.1819 9.66944 27.719 11.8182 27.719 14.0207C27.719 14.0744 27.719 14.1818 27.719 14.2356L35.0248 7.73555V0L26.3223 7.73555Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4091 14.0744C25.4091 6.33883 18.4794 0.0536973 9.99176 0.0536973V5.85536C15.2025 5.85536 19.4463 9.40082 19.6075 13.8058L15.686 17.2975C16.7066 19.124 17.405 21.1653 17.6736 23.3141L21.1653 20.1984C23.6364 24.9256 28.9546 28.1488 35.0786 28.1488V22.3471C29.7067 22.2934 25.4091 18.5868 25.4091 14.0744Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0331 38.8926V33.0909C19.7149 33.0909 15.4174 29.3843 15.4174 24.8719C15.4174 17.1363 8.48762 10.8512 0 10.8512V16.6529C4.5124 16.6529 8.32646 19.3388 9.34712 22.938L7.3058 24.7644L3.1157 28.5248L0 31.2644V39L10.5289 29.6529C12.624 34.9711 18.3182 38.8926 25.0331 38.8926Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXxNetworkCircleLogo);
export default __webpack_public_path__ + "static/media/xx-network-circle-logo.93d07ee84bebbd8f700e13f1f44220d0.svg";
export { ForwardRef as ReactComponent };